import React from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';

import { useContaCilContas } from '../../../../../../hooks/useContaCilContasBancarias';
import { useContaCilAgencias } from '../../../../../../hooks/useContaCilEmpresas';
import { useContaCilResumo } from '../../../../../../hooks/useContaCilLancamentos';
import { ContasTable } from '../../bancos/ContasTable';
import { ProgressoConciliacao } from '../../conciliar/components/ProgressoConciliacao';
import { AgenciaBancoChart, BarConciliacaoConta, DonutBancos, RankingContasBanco } from './charts';

export function AbaContas({ empresaId }: { empresaId: number }) {
  const { data: resumoData } = useContaCilResumo({ empresaId, page: 1, size: 1 });
  const { data: contas = [] } = useContaCilContas(empresaId);
  const { data: agencias = [] } = useContaCilAgencias(empresaId);
  const resumo = resumoData?.resumo;
  const porBancoConta = resumoData?.quebras.por_banco_conta ?? [];

  return (
    <Box>
      {/* Camada 1 — saúde */}
      {resumo && <ProgressoConciliacao resumo={resumo} />}

      {/* Camada 2 — visual */}
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <DonutBancos porBancoConta={porBancoConta} />
        <RankingContasBanco contas={contas} />
      </SimpleGrid>
      <Box mb={4}>
        <BarConciliacaoConta porBancoConta={porBancoConta} />
      </Box>
      <Box mb={5}>
        <AgenciaBancoChart dados={agencias} />
      </Box>

      {/* Camada 3 — operação (tabela banco↔POC compartilhada) */}
      <ContasTable empresaId={empresaId} />
    </Box>
  );
}
